export default __webpack_public_path__ + "static/media/category1.064ffeb2.png";